export default __webpack_public_path__ + "static/octagon-c663780a5a09d1d1d40ad7c3263a2d0e.png";